// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from './../../../../services/common/common.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { AssociateCropService } from './../../../../services/seed/associate-crop.service';
import { Subscription } from 'rxjs';

//pdf
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-associate-crop-summary',
  templateUrl: './associate-crop-summary.component.html',
  styleUrls: ['./associate-crop-summary.component.scss']
})
export class AssociateCropSummaryComponent implements OnInit, AfterViewInit, OnDestroy {

  //Array
  private subscription = new Array<Subscription>();
  associateOrderSource: MatTableDataSource<any>;
  shipToAccountdetails: any = {};
  deliverToAccountdetails: any = {};
  locationDetails: any = {};
  displayedColumns: any[] = ['marketingBrand', 'variety', 'orderQty', 'uom', 'preferredPackagingSize'];

  //Date
  deliveryDate: Date;

  //String
  webOrderNumber = '';
  orderStatus = '';
  deliveryInstruction = '';
  statusNotice: string = "Your order has been submitted. You will receive an e-mail confirmation.";

  //Boolean
  isInMobileApp = false;
  readOnlyAccess = false;
  userMenuAccessList: any;
  summaryResult: any;
  orderHeaderId: number = 0;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);

  constructor(private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private associateCropService: AssociateCropService,
    private commonService: CommonService) { }

  ngOnInit() {
    this.isInMobileApp = this.isInWebView();
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.getOrderDetails();
        } else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }
  }

  getOrderDetails() {
    this.subscription.push(this.associateCropService.confirmationSeedAssociateOrderId.subscribe(headerId => {
      if (headerId && headerId != 0) {
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.associateCropService.GetSeedCropAssociatesOrderSummaryData(headerId).subscribe((result: any) => {
          if (result) {

            this.summaryResult = result;
            //First Column
            this.orderHeaderId = result.orderHeaderID;
            this.webOrderNumber = result.orderHeaderID;
            this.shipToAccountdetails.CreatedOn = result.createdOn;
            this.shipToAccountdetails.PlacedByName = result.placedByName;
            this.shipToAccountdetails.CustomerPONumber = result.customerPO;
            this.shipToAccountdetails.CustomerPickUp = result.customerPickup == false ? 'NO' : 'YES';

            //Second Column (Associate Location)
            this.locationDetails.AccountName = result.associateName;
            this.locationDetails.Address = result.associateAddress;
            this.locationDetails.City = result.associateCity;
            this.locationDetails.State = result.associateState;
            this.locationDetails.ZipCode = result.associateZipcode;
            this.locationDetails.ContactName = result.associateContactName;
            this.locationDetails.Email = result.associateContactEmail;
            this.locationDetails.Phone = result.associatePhoneNumber;

            //Third Column (Ship To Details)
            this.shipToAccountdetails.AccountNumber = result.shipToAccount;
            this.shipToAccountdetails.AccountName = result.accountName;
            this.shipToAccountdetails.Address1 = result.shipToAddress1;
            this.shipToAccountdetails.Address2 = result.shipToAddress2;
            this.shipToAccountdetails.AccountCity = result.shipToCity;
            this.shipToAccountdetails.AccountState = result.shipToState;
            this.shipToAccountdetails.AccountZipCode = result.zipCode;
            this.shipToAccountdetails.Phone = result.primaryPhoneNumber;

            //Match Associate Location Details
            this.shipToAccountdetails.HasMatchAssociate = result.hasMatchAssociate;
            this.shipToAccountdetails.MatchAssociateName = result.matchAssociateName;
            this.shipToAccountdetails.MatchContactName = result.matchContactName;
            this.shipToAccountdetails.MatchAddress1 = result.matchAddress1;
            this.shipToAccountdetails.MatchAddress2 = result.matchAddress2;
            this.shipToAccountdetails.MatchCity = result.matchCity;
            this.shipToAccountdetails.MatchState = result.matchState;
            this.shipToAccountdetails.MatchZipCode = result.matchZipCode;
            this.shipToAccountdetails.MatchPhoneNumber = result.matchPhoneNumber;

            //Fourth Column (Deliver To  Details)
            if (result.deliverToAccount) {
              this.deliverToAccountdetails.AccountNumber = result.deliverToAccount;
              this.deliverToAccountdetails.AccountName = result.deliverToName;
              this.deliverToAccountdetails.Address1 = result.deliverToAddress1;
              this.deliverToAccountdetails.AccountCity = result.deliverToCity;
              this.deliverToAccountdetails.AccountState = result.deliverToState;
              this.deliverToAccountdetails.AccountZipCode = result.deliverToZipCode;
            }

            this.deliveryInstruction = result.deliverInstructions;
            this.orderStatus = "SUBMITTED";
            this.deliveryDate = result.requestDeliverDate;

            this.associateOrderSource = new MatTableDataSource(result.detailsData);

          }
          this.loaderService.setLoaderStatus(false);
        }, (error) => {
          this.loaderService.setLoaderStatus(false);
        }));

      }
    }));
  }

  isInWebView(): boolean {
    const ua = navigator.userAgent || '';

    // React Native WebView
    if ((window as any).ReactNativeWebView) return true;

    // iOS WebView: AppleWebKit but NOT Safari
    const isIOS = /iPhone|iPod|iPad/i.test(ua);
    const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView: look for 'wv' or no 'Chrome' version string
    const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

    return isIOSWebView || isAndroidWebView;
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.prepayContractOuter').css('height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  generatePdf() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(
      this.associateCropService.downloadPdfForMobile(this.summaryResult).subscribe(result => {
        if (this.isInMobileApp) {
          var fileData = {
            MobilePDFBase64: result.mobilePDFBase64,
            FileName: result.fileName
          };

          this.subscription.push(this.associateCropService.sendBaseDate(fileData).subscribe((result) => {
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
        else {
          this.downloadFile(result.mobilePDFBase64, result.fileName);
        }
        this.loaderService.setLoaderStatus(false);
      },
        () => {
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  downloadFile(base64String, fileName) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  // Create a new  order(navigate to new order screen)
  createNewOrder() {
    this.router.navigate(['/associate-crop/associate-crop-create-order']);
  }

  backToLandingPage() {
    this.router.navigate(['/associate-crop-landing']);
  }

  ngOnDestroy() {
    this.associateCropService.setconfirmationSeedAssociateOrderId(0);
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }


}
